// Cookie utility functions

export function setCookie(name, value, expires) {
  let cookie = `${name}=${value}; path=/;`;
  if (expires) {
    cookie += ` expires=${new Date(expires).toUTCString()};`;
  }
  document.cookie = cookie;
}

export function eraseCookie(name) {
  document.cookie = name + "=; Max-Age=0; path=/;";
}

export function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}
